import axios from "axios";
import { saveAs } from "file-saver";

// const BASE_URL = "http://localhost:9000";
const BASE_URL = "https://loadgat.depedimuscity.com:8020";

function exportSubmissionsByPost(id) {
  return axios.get(`${BASE_URL}/I-ABIDE/filteredReport/exportExcel/${id}`, {
    responseType: "arraybuffer", // Specify response type as arraybuffer
  });
}

function createDirectory(data) {
  return axios
    .post(`${BASE_URL}/I-Abide/create-folder`, data)
    .then((res) => res.data)
    .catch((error) => {
      console.error("Error creating directory:", error);
      throw error;
    });
}

function createPost(data) {
  return axios
    .post(`${BASE_URL}/I-Abide/createPost`, data)
    .then((res) => res.data)
    .catch((error) => {
      console.error("Error creating post:", error);
      throw error;
    });
}

function updateSubmissionStatus(id, newStatus, remarks) {
  return axios
    .put(`${BASE_URL}/I-Abide/acceptRejectDocument/${id}`, {
      newStatus,
      remarks,
    })
    .then((res) => res.data)
    .catch((error) => {
      console.error("Error updating submission status:", error);
      throw error;
    });
}

function getSubmissionsByPost(id) {
  return axios
    .get(`${BASE_URL}/I-Abide/getAllSubmissionsByPost/${id}`)
    .then((res) => res.data)
    .catch((error) => {
      console.error("Error updating submission status:", error);
      throw error;
    });
}

function getBulkRecipients() {
  return axios
    .get(`${BASE_URL}/I-Abide/getAllRecipients`)
    .then((res) => res.data);
}

function getAllRejects() {
  return axios
    .get(`${BASE_URL}/I-Abide/getAllRejectedSubmissions`)
    .then((res) => res.data);
}

function getAllDirectories() {
  return axios
    .get(`${BASE_URL}/I-Abide/getAllDirectories`)
    .then((res) => res.data);
}

function createSubDirectory(data) {
  return axios
    .post(`${BASE_URL}/I-Abide/create-subdirectory`, data)
    .then((res) => res.data)
    .catch((error) => {
      console.error("Error creating subdirectory:", error);
      throw error;
    });
}

function getSubdirectoriesByParentId(parentDirectoryId) {
  return axios
    .get(`${BASE_URL}/I-Abide/getSubdirectories/${parentDirectoryId}`)
    .then((res) => res.data)
    .catch((error) => {
      console.error("Error fetching subdirectories:", error);
      throw error;
    });
}

function viewPostById(id) {
  return axios
    .get(`${BASE_URL}/I-Abide/getPost/${id}`)
    .then((res) => res.data)
    .catch((error) => {
      console.error("Error fetching subdirectories:", error);
      throw error;
    });
}

function getAllSubmissions() {
  return axios
    .get(`${BASE_URL}/I-Abide/getAllSubmissions`)
    .then((res) => res.data)
    .catch((error) => {
      console.error("Error fetching submissions:", error);
      throw error;
    });
}

function getAllOffices() {
  return axios
    .get(`${BASE_URL}/I-Abide/getAllOffices`)
    .then((res) => res.data)
    .catch((error) => {
      console.error("Error fetching offices:", error);
      throw error;
    });
}

function getAllSubmissionTypes() {
  return axios
    .get(`${BASE_URL}/I-Abide/getSubmissionTypes`)
    .then((res) => res.data)
    .catch((error) => {
      console.error("Error fetching submissions:", error);
      throw error;
    });
}

function submitDocument(data) {
  return axios
    .post(`${BASE_URL}/I-Abide/submitDocument`, data, {
      headers: {
        "Content-Type": "multipart/form-data", // Set the content type to handle file uploads
      },
    })
    .then((res) => res.data)
    .catch((error) => {
      console.error("Error submitting document:", error);
      throw error;
    });
}

function getSubmissionsByLocationName(locationName) {
  return axios
    .get(`${BASE_URL}/I-Abide/getSubmissionsByLocationName/${locationName}`)
    .then((res) => {
      const submissions = res.data.data.map((office) => ({
        officeRelated: office.officeRelated,
        submissions: office.submissions,
      }));
      return { message: res.data.message, data: submissions };
    })
    .catch((error) => {
      console.error("Error fetching submissions by location name:", error);
      throw error;
    });
}

function getOfficesByLocation(location) {
  return axios
    .get(`${BASE_URL}/I-Abide/getOfficesByLoc`, { params: { location } })
    .then((res) => {
      console.log("API Response:", res); // Add this to debug the API call
      return res.data;
    })
    .catch((error) => {
      console.error("Error fetching offices by location:", error);
      throw error;
    });
}

function getSubmissionByPostandUsername(username, id) {
  return axios
    .get(`${BASE_URL}/I-Abide/getSubmissionByPostandUser`, {
      params: { username, id },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error(
        "Error fetching submission for user:",
        username,
        "and post ID:",
        id,
        error
      );
      throw error;
    });
}

function getPostsByRecipient(id) {
  return axios
    .get(`${BASE_URL}/I-Abide/getPostByRecipient/${id}`)
    .then((res) => res.data)
    .catch((error) => {
      console.error("Error fetching posts by recipient:", error);
      throw error;
    });
}

function getOfficeById(id) {
  return axios
    .get(`${BASE_URL}/I-Abide/getOfficeById/${id}`)
    .then((res) => res.data)
    .catch((error) => {
      console.error("Error fetching office:", error);
      throw error;
    });
}

function getFileUrlBySubmissionId(submissionId) {
  return axios
    .get(`${BASE_URL}/I-Abide/viewFile`, { params: { submissionId } })
    .then((res) => {
      // Log to verify the structure
      console.log("Full Response:", res);
      // Ensure we're correctly accessing fileUrl
      return res.data.fileUrl;
    })
    .catch((error) => {
      console.error("Error fetching file URL:", error);
      throw error;
    });
}

function bulkDownload(postId) {
  return axios
    .post(`${BASE_URL}/I-Abide/bulkDownload/${postId}`, null, {
      responseType: "blob", // Expect a binary response (ZIP file)
    })
    .then((response) => {
      // Handle the ZIP file response
      const blob = response.data;
      const fileName = `bulk_download_${postId}.zip`; // You can adjust the file name as needed
      saveAs(blob, fileName); // Trigger file download
    })
    .catch((error) => {
      console.error("Error downloading bulk files:", error);
      alert("An error occurred while downloading the files.");
    });
}

function getSubmissionsByOfficeType(id) {
  return axios
    .get(`${BASE_URL}/I-Abide/getSubmissionsByOfficeType/${id}`)
    .then((res) => {
      // Log to verify the structure
      console.log("Full Response:", res);
      // Ensure we're correctly accessing fileUrl
      return res;
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
      alert("An error occurred while fetching the data.");
    });
}

function resubmitDocument(data) {
  return axios
    .post(`${BASE_URL}/I-Abide/resubmitDocument`, data, {
      headers: {
        "Content-Type": "multipart/form-data", // Ensure file upload is handled
      },
    })
    .then((res) => res.data)
    .catch((error) => {
      console.error("Error resubmitting document:", error);
      throw error;
    });
}

export default {
  getAllOffices,
  getSubmissionsByOfficeType,
  resubmitDocument,
  getOfficesByLocation,
  bulkDownload,
  getAllRejects,
  getFileUrlBySubmissionId,
  getAllSubmissionTypes,
  getOfficeById,
  getSubmissionByPostandUsername,
  getPostsByRecipient,
  getSubmissionsByLocationName,
  exportSubmissionsByPost,
  getSubmissionsByPost,
  updateSubmissionStatus,
  submitDocument,
  viewPostById,
  getBulkRecipients,
  getAllDirectories,
  getSubdirectoriesByParentId,
  createSubDirectory,
  createDirectory,
  createPost,
  getAllSubmissions,
};
